import createAsyncData from 'modules/core/hooks/createAsyncData'

import { TasksFiles } from 'modules/tasks/store/collections/tasks_files'

export const useFetchTaskFiles = createAsyncData(
  (tasksFiles: TasksFiles, accessId: string, taskId: string) =>
    tasksFiles.fetch({
      data: {
        access_id: accessId,
        task_id: taskId,
      },
    })
)
